import React from 'react';
export const MyContext = React.createContext({} as any);